import axios from "axios";
import api from "../../lib/api/api";
import {
  START_SESSION_SUCCESS,
  START_SESSION_FAIL,
  CHEATING_ATTEMPT_RESPONSE,
  CHEATING_ATTEMPT_FAIL,
  SET_BLACKLIST_STATUS,
  BLACKLIST_STATUS_FAIL
} from "./types";

const API = process.env.REACT_APP_API_URL;

const extractApiError = (error, fallback) => {
  const data = error?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  if (data?.message) return data.message;
  if (data?.error) return data.error;
  if (data?.detail) return data.detail;
  if (error?.message) return error.message;
  return fallback;
};

// redux/Actions/placementSecurityActions.js (keep axios + API as you have)
export const startPlacementSession = (targetLevel = "A2") => async (dispatch) => {
  try {
    const guestToken = localStorage.getItem("placementGuestToken");
    if (guestToken) {
      localStorage.removeItem("placementGuestToken");
      localStorage.removeItem("placementGuestStudentId");
    }
    const res = await api.post("/placement/monitor/session/start", null, {
      params: { targetLevel },
    });
    console.log("[startPlacementSession] OK", res.status);
    dispatch({ type: START_SESSION_SUCCESS });
    return { ok: true };
  } catch (error) {
    const data = error?.response?.data;
    const msg = extractApiError(error, "Failed to start session");
    const code = typeof data === "object" ? data?.code : undefined;
    console.error("[startPlacementSession] FAIL", code, msg);
    dispatch({ type: START_SESSION_FAIL, payload: msg });
    return { ok: false, error: msg, code, status: error?.response?.status };
  }
};

export const startGuestPlacementSession = (payload) => async (dispatch) => {
  try {
    const res = await axios.post(`${API}/api/placement/guest/session/start`, payload);
    localStorage.setItem("placementGuestToken", res.data.guestToken);
    localStorage.setItem("placementGuestStudentId", String(res.data.studentId));
    localStorage.setItem("placementGuestEmail", String(payload.email || "").trim().toLowerCase());
    dispatch({ type: START_SESSION_SUCCESS });
    return { ok: true, data: res.data };
  } catch (error) {
    const data = error?.response?.data;
    const msg = extractApiError(error, "Failed to start guest session");
    const code = typeof data === "object" ? data?.code : undefined;
    dispatch({ type: START_SESSION_FAIL, payload: msg });
    return { ok: false, error: msg, code };
  }
};

export const requestGuestPlacementEmailCode = async (email) => {
  try {
    const res = await axios.post(`${API}/api/placement/guest/email-verification/request`, { email });
    return { ok: true, data: res.data };
  } catch (error) {
    return { ok: false, error: extractApiError(error, "Could not send the verification code"), code: error?.response?.data?.code };
  }
};

export const verifyGuestPlacementEmailCode = async (email, code) => {
  try {
    const res = await axios.post(`${API}/api/placement/guest/email-verification/verify`, { email, code });
    return { ok: true, token: res.data?.verificationToken };
  } catch (error) {
    return { ok: false, error: extractApiError(error, "The verification code is invalid"), code: error?.response?.data?.code };
  }
};

export const registerCheatingAttempt = () => async (dispatch) => {
  try {
    const guestToken = localStorage.getItem("placementGuestToken");
    const url = guestToken
      ? `${API}/api/placement/guest/attempt`
      : `${API}/api/placement/monitor/attempt`;
    const res = await axios.post(url, null, guestToken ? { params: { token: guestToken } } : undefined);
    console.log("[registerCheatingAttempt] OK", res.data);
    dispatch({ type: CHEATING_ATTEMPT_RESPONSE, payload: res.data });
    return { ok: true, data: res.data };
  } catch (error) {
    const data = error?.response?.data;
    const msg = typeof data === "string" ? data : data?.message || "Failed to register attempt";
    const code = typeof data === "object" ? data?.code : undefined;
    console.error("[registerCheatingAttempt] FAIL", code, msg);
    dispatch({ type: CHEATING_ATTEMPT_FAIL, payload: msg });
    return { ok: false, error: msg, code };
  }
};

export const checkBlacklistStatus = () => async (dispatch) => {
  try {
    const guestToken = localStorage.getItem("placementGuestToken");
    const res = guestToken
      ? await axios.get(`${API}/api/placement/guest/status`, { params: { token: guestToken } })
      : await axios.get(`${API}/api/placement/monitor/is-blacklisted`);
    console.log("[checkBlacklistStatus] OK", res.data);
    dispatch({ type: SET_BLACKLIST_STATUS, payload: !!res.data.blacklisted });
    return { ok: true, data: res.data };
  } catch (error) {
    const data = error?.response?.data;
    const msg = typeof data === "string" ? data : data?.message || "Blacklist check failed";
    const code = typeof data === "object" ? data?.code : undefined;
    console.error("[checkBlacklistStatus] FAIL", code, msg);
    dispatch({ type: BLACKLIST_STATUS_FAIL, payload: msg });
    return { ok: false, error: msg, code };
  }
};
